import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';
import Toggleable from 'views/plugins/ui/toggleable';
import PricingStore from 'stores/plugins/pricing';
import BookingRequestStore from 'stores/plugins/booking_request';
import PricingActionCreator from 'action_creators/pricing';
import Loader from 'views/ui/loaders/three_dots';
import Deposit from './deposit';
import Remainder from './remainder';
import Breakdown from './breakdown';
import Subtotal from './subtotal';
import CashPaymentNotice from './cash_payment_notice';

class CheckoutSummaryPricing extends React.Component {
  static displayName = 'CheckoutSummaryPricing';

  static propTypes = {
    toggleable_breakdown: PropTypes.bool,
    expanded_price_breakdown: PropTypes.bool,
    display_subtotal_icon: PropTypes.bool,
  };

  static defaultProps = {
    display_subtotal_icon: true,
    expanded_price_breakdown: false,
    toggleable_breakdown: true,
  };

  state = {
    subtotal: '',
    includes_booking_fee: true,
    booking_fee: '',
    number_of_guests: 0,
    addons: {},
    units: {},
    paid_in_cash: null,
    for_zero_priced_tour: false,
  };

  componentDidMount() {
    PricingStore.changed.add(this._pricingChanged);
    BookingRequestStore.changed.add(this._bookingRequestChanged);
  }

  componentWillUnmount() {
    PricingStore.changed.remove(this._pricingChanged);
    BookingRequestStore.changed.remove(this._bookingRequestChanged);
  }

  _pricingChanged = () => {
    this.setState({
      booking_fee_formatted: PricingStore.state.get('booking_fee_formatted'),
      includes_booking_fee:
        parseFloat(PricingStore.state.get('booking_fee')) > 0,
      discount_formatted: PricingStore.state.get('discount_formatted'),
      discount_code: BookingRequestStore.state.get('discount_code'),
      includes_discount: parseFloat(PricingStore.state.get('discount')) > 0,
      online_discount_formatted: PricingStore.state.get(
        'online_discount_formatted'
      ),
      includes_online_discount:
        parseFloat(PricingStore.state.get('online_discount')) > 0,
      deposit_formatted: PricingStore.state.get('deposit_formatted'),
      requires_deposit: parseFloat(PricingStore.state.get('deposit')) > 0,
      unit_price_formatted: PricingStore.state.get('unit_price_formatted'),
      guests_price_formatted: PricingStore.state.get('guests_price_formatted'),
      guests: PricingStore.state.get('guests'),
      units: PricingStore.state.get('units').toJSON(),
      addons: PricingStore.state.get('addons').toJS(),
      total_formatted: PricingStore.state.get('total_formatted'),
      additional_tax: PricingStore.state.get('additional_tax'),
      additional_tax_formatted: PricingStore.state.get(
        'additional_tax_formatted'
      ),
      additional_tax_label: PricingStore.state.get('additional_tax_label'),
      remainder_formatted: PricingStore.state.get('remainder_formatted'),
      remainder_payment_date: PricingStore.state.get('remainder_payment_date'),
      remainder_in_cash: PricingStore.state.get('remainder_in_cash'),
      remainder_in_credit: PricingStore.state.get('remainder_in_credit'),
      remainder_charge_days_offset: PricingStore.state.get(
        'remainder_charge_days_offset'
      ),
      remainder_in_local_currency: PricingStore.state.get(
        'remainder_in_local_currency'
      ),
      remainder_in_local_currency_formatted: PricingStore.state.get(
        'remainder_in_local_currency_formatted'
      ),
      paid_in_cash: PricingStore.state.get('paid_in_cash'),
      total_in_local_currency: PricingStore.state.get(
        'total_in_local_currency'
      ),
      total_in_local_currency_formatted: PricingStore.state.get(
        'total_in_local_currency_formatted'
      ),
      total_in_local_currency_exact: PricingStore.state.get(
        'total_in_local_currency_exact'
      ),
      total_in_local_currency_exact_formatted: PricingStore.state.get(
        'total_in_local_currency_exact_formatted'
      ),
      loading: PricingStore.state.get('loading'),
    });
  };

  _bookingRequestChanged = () => {
    if (!this.state.loading) {
      this._previewPricing();
    }
  };

  _previewPricing = () => {
    if (!this.state.loading) {
      const params = this.props.bookingId
        ? { bookingId: this.props.bookingId }
        : {};

      // Add time from props if available (for server-rendered data)
      if (this.props.time) {
        params.time = this.props.time;
      }

      PricingActionCreator.preview(params);
    }
  };

  subtotalProps = () => {
    return {
      displayIcon: this.props.display_subtotal_icon,
      amount: this.state.total_formatted,
    };
  };

  depositProps = () => {
    return {
      amount: this.state.deposit_formatted,
    };
  };

  breakdownProps = () => {
    return {
      booking_fee_formatted: this.state.booking_fee_formatted,
      includes_booking_fee: this.state.includes_booking_fee,
      includes_discount: this.state.includes_discount,
      discount_formatted: this.state.discount_formatted,
      discount_code: this.state.discount_code,
      online_discount_formatted: this.state.online_discount_formatted,
      includes_online_discount: this.state.includes_online_discount,
      includes_additional_tax: this.state.additional_tax > 0,
      additional_tax_formatted: this.state.additional_tax_formatted,
      additional_tax_label: this.state.additional_tax_label,
      guests: this.state.guests,
      units: this.state.units,
      unit_price_formatted: this.state.unit_price_formatted,
      guests_price_formatted: this.state.guests_price_formatted,
      addons: this.state.addons,
      expanded: this.props.expanded_price_breakdown,
    };
  };

  remainderProps = () => {
    return {
      remainder_formatted: this.state.remainder_formatted,
      remainder_in_local_currency_formatted:
        this.state.remainder_in_local_currency_formatted,
      remainder_payment_date: this.state.remainder_payment_date,
      remainder_in_cash: this.state.remainder_in_cash,
      remainder_in_credit: this.state.remainder_in_credit,
      remainder_charge_days_offset: this.state.remainder_charge_days_offset,
      date: this.props.date,
      guide_full_name: this.props.guide_full_name,
    };
  };

  cashPaymentNoticeProps = () => {
    return {
      date: this.props.date,
      total_formatted: this.state.total_formatted,
      total_in_local_currency_formatted:
        this.state.total_in_local_currency_formatted,
    };
  };

  _renderToggleableBreakdown = () => {
    return (
      <Toggleable
        handler={<Subtotal {...this.subtotalProps()} />}
        content={<Breakdown {...this.breakdownProps()} />}
      />
    );
  };

  _renderBreakdown = () => {
    return (
      <div className="Subtotal-Breakdown-NonToggleable">
        <Subtotal {...this.subtotalProps()} />
        <Breakdown {...this.breakdownProps()} />
      </div>
    );
  };

  _renderToggleable = () => {
    return this._renderToggleableBreakdown();
  };

  _shouldRenderDepositRemainder = () => {
    return (
      !this.state.paid_in_cash &&
      this.state.requires_deposit &&
      this.state.deposit_formatted !==
        this.state.total_in_local_currency_exact_formatted
    );
  };

  render() {
    /*
      A refactor is needed in guest checkout - to do better than this unseemly render method
      These steps prevent jumping of UI.
    */
    // 1. Return null if state loading and it's a free tour
    if (
      !this.state.total_in_local_currency &&
      this.props.for_zero_priced_tour
    ) {
      return null;
    }
    // 2. Return loader if not a free tour and state laoding
    if (!this.state.total_in_local_currency) {
      return (
        <div style={{ height: '60px', position: 'relative' }}>
          <Loader key="loader" className="dot-10 dark centered" />
        </div>
      );
    }
    const total = Number(this.state.total_in_local_currency);
    // 3. Return pricing if state loaded and not a free tour or...
    // total $ is not zero (eg: free tour with addons)
    if (!this.props.for_zero_priced_tour || total !== 0) {
      return (
        <div className="CheckoutSummary-Subtotal-PriceBreakdown-Deposit">
          <div className="CheckoutSummary-ContentBox Subtotal-PriceBreakdown">
            {this._renderToggleable()}
          </div>
          {this._shouldRenderDepositRemainder() ? (
            <Deposit {...this.depositProps()} />
          ) : null}
          {this._shouldRenderDepositRemainder() ? (
            <Remainder {...this.remainderProps()} />
          ) : null}
          {this.state.paid_in_cash ? (
            <CashPaymentNotice {...this.cashPaymentNoticeProps()} />
          ) : null}
        </div>
      );
    }
    // 4. If we get here, this must be state loaded and free tour without addons (0 total)
    return null;
  }
}

export default CheckoutSummaryPricing;
